








import Vue from 'vue';
import store from '../store';

export default Vue.component('bacon-dump', {
    data() {
        return {
            isProduction: process.env.NODE_ENV === 'production',
        };
    },
    props: ['dump'],
});
